import { observable } from "mobx";
import { Type } from "class-transformer";
import PaymentListPaymentsItem from "./paymentListPaymentsItem";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class PaymentList {
  @observable
  total!: number;

  @observable
  @Type(() => PaymentListPaymentsItem)
  payments!: PaymentListPaymentsItem[];

  static ValidationRules = {
    total: { required: true, number: true },
    payments: { required: true },
  };
}
